// libs/election-api-types/src/election-api-types.ts
import {
  array,
  boolean,
  enum as enum2,
  number,
  object,
  record,
  string
} from "zod";
var partyCodeSchema = enum2([
  "ACP",
  "ALP",
  "AJP",
  "GRN",
  "IND",
  "LBT",
  "LCWA",
  "LIB",
  "NAT",
  "OTH",
  "PHON",
  "SFFP",
  "SPPk",
  "WAXIT",
  "COA",
  "UAP",
  "ASP",
  "AUC",
  "AUD",
  "AV",
  "BTP",
  "CEC",
  "CLP",
  "CYA",
  "DAVI",
  "DLFC",
  "FFPA",
  "GAP",
  "GRPF",
  "GVIC",
  "HMP",
  "IAP",
  "IMO",
  "JLN",
  "KAP",
  "KCBR",
  "LNP",
  "LP",
  "LTP",
  "NP",
  "ON",
  "SAL",
  "SOPA",
  "SPP",
  "TTFT",
  "VNS",
  "XEN"
]);
var partyNamesSchema = object({
  partyName: string(),
  shortPartyName: string().optional()
});
var partyInfoSchema = record(partyCodeSchema, partyNamesSchema);
var areaCodeSchema = enum2([
  "ACT",
  "NSW",
  "NT",
  "QLD",
  "SA",
  "TAS",
  "VIC",
  "WA",
  "Federal"
]);
var predictionBasisSchema = enum2(["Algorithm", "Manual", "None"]);
var predictionCertaintySchema = enum2([
  "InDoubt",
  "TooClose",
  "Probable",
  "Definite"
]);
var partyDtoSchema = object({
  state: string(),
  partyCode: partyCodeSchema.or(string()),
  partyName: string().optional(),
  shortPartyName: string().optional(),
  isCoalition: boolean(),
  swingPct: number().nullable(),
  seatsWon: number(),
  seatsAhead: number(),
  seatsChanged: number(),
  seatsPredicted: number().nullable(),
  seatsLost: number().optional(),
  seatsGained: number().optional(),
  votePct: number(),
  voteCount: number(),
  tpp: number(),
  tppChange: number(),
  tppHistorical: number()
});
var candidatesDtoSchema = object({
  candidateId: number(),
  firstName: string().nullable(),
  lastName: string(),
  partyCode: string(),
  partyName: string().optional(),
  shortPartyName: string().optional(),
  photoUrl: string(),
  seatId: string(),
  isIncumbent: boolean(),
  swingPct: number().nullable(),
  primaryVotesPct: number(),
  primaryVotes: number()
});
var twoPartyPreferredDtoSchema = object({
  seatCode: string(),
  partyCode: string(),
  candidateId: number(),
  candidateFirstName: string().nullable(),
  candidateLastName: string(),
  candidatePartyCode: string().nullable(),
  candidatePartyName: string().optional(),
  candidateShortPartyName: string().optional(),
  incumbent: boolean(),
  primaryVotes: number(),
  changePrimaryPct: number().nullable(),
  changeTcpPct: number().nullable(),
  tcpVotesPctCurrent: number().nullable(),
  winner: boolean()
});
var seatDtoSchema = object({
  seatId: string(),
  seatName: string(),
  seatRegion: string(),
  state: string(),
  shortState: string().optional(),
  postcodes: array(number()).readonly(),
  incumbentName: string().nullable(),
  incumbentParty: string().nullable(),
  incumbentIsCoalition: boolean(),
  incumbentPartyCode: string().optional(),
  predictionBasis: predictionBasisSchema.optional(),
  predictionCertainty: predictionCertaintySchema.optional(),
  predictionParty: string().optional(),
  candidates: array(candidatesDtoSchema),
  twoPartyPreferred: array(twoPartyPreferredDtoSchema),
  swingPct: number().nullable(),
  lastUpdated: string().nullable(),
  isKeySeat: boolean().optional(),
  keySeatIndex: number().optional(),
  pctCounted: number().nullable().optional()
});
var areaDtoSchema = object({
  electionId: number(),
  areaCode: string(),
  areaName: string(),
  parties: array(partyDtoSchema),
  pctCounted: number()
});
var electionConfigSchema = object({
  enabled: boolean(),
  electionApi: object({
    electionId: string(),
    frequency: number()
  }),
  mapApiUrl: string().optional().nullable(),
  seatsToWin: number(),
  seatsTotal: number(),
  barTotalSeats: number(),
  electionTitle: string(),
  electionDate: string(),
  electionType: string(),
  state: string().optional()
});
var isElectionConfig = (obj) => {
  return electionConfigSchema.safeParse(obj).success;
};
var seatsPredictedSchema = record(string(), number());

// libs/election-api-types/src/election-response-types.ts
import {
  array as array2,
  nullable,
  number as number2,
  object as object2,
  string as string2
} from "zod";
var transformedDataSchema = object2({
  areas: array2(areaDtoSchema),
  seats: array2(seatDtoSchema),
  needle: number2().optional(),
  totalArea: nullable(areaDtoSchema).optional(),
  lastModified: string2().datetime()
});
var electionDataResponseSchema = object2({
  data: transformedDataSchema.optional(),
  config: electionConfigSchema.optional()
});
var electionsElectionDefinition = object2({
  wanElectionId: string2(),
  objectKey: string2()
});
var electionsResponseSchema = array2(electionsElectionDefinition);
export {
  areaCodeSchema,
  areaDtoSchema,
  candidatesDtoSchema,
  electionConfigSchema,
  electionDataResponseSchema,
  electionsElectionDefinition,
  electionsResponseSchema,
  isElectionConfig,
  partyCodeSchema,
  partyDtoSchema,
  seatDtoSchema,
  transformedDataSchema,
  twoPartyPreferredDtoSchema
};
//# sourceMappingURL=index.js.map
